
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M14.773 4.066L9.87.478a2.485 2.485 0 00-3.006.057l-4.943 3.92A2.421 2.421 0 001 6.35v7.217C1 14.911 2.102 16 3.462 16h9.846c1.36 0 2.461-1.089 2.461-2.432V6.021c0-.771-.37-1.496-.996-1.955zM11.667 14.38h1.64a.815.815 0 00.821-.81V6.02a.807.807 0 00-.332-.652L8.893 1.781a.828.828 0 00-1.002.019L2.948 5.72a.807.807 0 00-.307.631v7.217c0 .448.367.81.82.81h1.642v-2.431c0-1.791 1.469-3.243 3.282-3.243 1.812 0 3.282 1.452 3.282 3.243v2.432zm-4.923 0h3.282v-2.432a1.63 1.63 0 00-1.641-1.621 1.63 1.63 0 00-1.641 1.62v2.433z"}})])
          )
        }
      }
    